import * as React from 'react';
import { Button } from '../bootstrap-components/BootstrapComponents';

export interface SubmitButtonProps {
    children: any;   
    isSubmitting: boolean;
}

class SubmitButton extends React.Component<SubmitButtonProps, {}> {
    constructor(props: SubmitButtonProps) {
        super(props);
        
//        this.onClick = this.onClick.bind(this);
    }

    // onClick(e: any) {
    //     this.props.onSubmit();
    // }

    render() {
        return (
            <Button type='submit' className='spacer' buttonType='primary' disabled={this.props.isSubmitting}>{this.props.children}</Button>
        );
    }
}

export default SubmitButton;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/input/SubmitButton.tsx